import { get } from "lodash";

import { calendarViews } from "../constants/common";
import { SET_SCHEDULER_FILTERS } from "../constants/actionTypes";

import { setToMidnight } from "../utils/date";
import {
  dataStoreGet,
  dataStorePost,
  dataStorePut,
} from "../utils/userDataStore";

const defaultState = {
  filters: {
    showCustomTimeSlots: true,
    calendarView: calendarViews.weekly,
    startDate: new Date(
      setToMidnight(
        new Date(new Date().getTime() - new Date().getDay() * 86400000)
      )
    ),
  },
};

export const initiateSchedulerFilters = (type) => {
  return async (dispatch, getState) => {
    let defaultFilters;
    // Fetch from datastore
    try {
      defaultFilters = await dataStoreGet(`schedulerFilters${type}`);
      if (defaultFilters) {
        defaultFilters = JSON.parse(defaultFilters);
        defaultFilters.startDate = new Date(get(defaultFilters, ["startDate"]));
      }
    } catch (e) {
      console.log(e);
    }

    if (!defaultFilters) {
      defaultFilters = get(defaultState, ["filters"]);
      defaultFilters.site = get(getState(), ["user", "assignedSite"]);
      try {
        await dataStorePost(
          `schedulerFilters${type}`,
          JSON.stringify(defaultFilters)
        );
      } catch (e) {
        console.log(e);
      }
    }

    dispatch({
      type: SET_SCHEDULER_FILTERS,
      section: type,
      payload: defaultFilters,
    });
  };
};

export const setSchedulerFilters = (type, filters) => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_SCHEDULER_FILTERS,
      section: type,
      payload: filters,
    });

    // Save into datastore
    try {
      dataStorePut(`schedulerFilters${type}`, JSON.stringify(filters));
    } catch (e) {
      console.log(e);
    }
  };
};
